import Styled from 'styled-components';

export const Container = Styled.div`
	position: relative;
	background-color: ${props =>
		props.active
			? props.theme.colors
				? props.theme.colors.forecastPurple
				: '#6e0fea'
			: props.theme.colors
			? props.theme.colors.mediumVeryLightGray
			: '#a1a1a1'};
	height: 20px;
	display: inline-block;
	min-width: 10px;
	max-width: ${props => !props.edit && `${props.maxWidth}px`};
	padding: 0 3px;
	border-radius: 2px;
	cursor:pointer;	
`;

export const ContentContainer = Styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;

`;

export const DropdownContainer = Styled.div`
	position: absolute;
	/* 5px extra for margin */
	top: '30px'; 
	left:'0px';
	height: 100px;
	z-index: 100000;
`;
export const TextContainer = Styled.div`
	overflow: hidden;
	display:flex;
	margin: 0 3px 0 3px;

	span {
		width: 100%;
		height: 100%;
		outline: none;
		overflow:hidden;
		text-overflow: ellipsis;
		padding: ${props => (props.edit ? '0 6px' : '0 6px 0 6px')};
		color: ${props => (props.active || props.edit ? '#fff' : props.theme.colors.textgray)};
		background-color: ${props => (props.edit ? (props.active ? 'rgba(256,256,266, .3)' : 'rgba(0,0,0,.4)') : 'transparent')};
		white-space: nowrap;
		border-radius: 2px;
		cursor: ${props => (props.edit ? 'text' : 'pointer')};
		font-size: 11px;
		//min-width: 60px;
		min-height:14px;
		&:empty:before{
			content: attr(data-placeholder);
			opacity:0.3;
		}
	}
`;

export const IconContainer = Styled.div`
	cursor: pointer;
	&:hover {
		opacity: 0.8;
	}
`;
